export type Toast = { id: number; text: string };
let items: Toast[] = [];
let next = 1;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

/** Show a short message at the corner of the screen; it goes away by itself. */
export function toast(text: string) {
  if (items.some((t) => t.text === text)) return;
  const id = next++;
  items = [...items, { id, text }];
  emit();
  setTimeout(() => dismissToast(id), 8000);
}

export function dismissToast(id: number) {
  items = items.filter((t) => t.id !== id);
  emit();
}

export const toasts = () => items;
export function subscribeToasts(f: () => void) {
  subs.add(f);
  return () => void subs.delete(f);
}
